module.exports = __webpack_public_path__ + "media/images/pic/keyboard-401ed67112f03a12bf69e0467e27ee40.svg";